import { getProviders } from './get-providers';

export const getProviderIDs = () => getProviders().map(({ id }) => id);
